import { FC } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import { IlogisticServiceDetails, IlogisticServiceTrelloCardData } from '../../../../../types/services';
import PendingToConfirmedModalLSContent from './PendingToConfirmedModalLSContent';
import { TchangeLogisticServiceStatusCallback } from '../LogisticsServicesTrelloModals';

interface IPendingToConfirmedModalLS {
  closeAndRestoreList?: () => void;
  onlyItemCard: IlogisticServiceTrelloCardData;
  logisticServiceDetails?: IlogisticServiceDetails;
  changeLogisticServiceStatusCallback: TchangeLogisticServiceStatusCallback;
  loadingChangeLSStatus?: boolean;
  closeModal?: () => void;
}

const PendingToConfirmedModalLS: FC<IPendingToConfirmedModalLS> = ({
  closeAndRestoreList,
  onlyItemCard,
  logisticServiceDetails,
  changeLogisticServiceStatusCallback,
  loadingChangeLSStatus,
  closeModal
}: IPendingToConfirmedModalLS) => {
  return (
    <NudosGenericModal
      closeModalCallback={() => {
        if (closeAndRestoreList) {
          closeAndRestoreList();
        }
      }}
      clickOutsideCallback={() => {
        if (closeAndRestoreList) {
          closeAndRestoreList();
        }
      }}
      modalContent={
        <NudosModalContent
          noScroll
          toCloseModal={() => {
            if (closeAndRestoreList) {
              closeAndRestoreList();
            }
          }}
          customWidth="780px"
          customHeight="580px"
          modalContentTitle="Pendiente de confirmación a Confirmado"
          CustomModalComponent={
            <PendingToConfirmedModalLSContent
              onlyItemCard={onlyItemCard}
              logisticServiceDetails={logisticServiceDetails}
              changeLogisticServiceStatusCallback={changeLogisticServiceStatusCallback}
              loadingChangeLSStatus={loadingChangeLSStatus}
              closeModal={closeModal}
            />
          }
        />
      }
    />
  );
};

export default PendingToConfirmedModalLS;
